// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 760px) {
  .Values_values__KR4R9 {
    padding-top: 20px;
  }
}
@media (max-width: 760px) {
  .Values_values__KR4R9 .Values_items__ihfsA {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr {
  box-sizing: border-box;
  width: calc(100% + 100px);
  display: flex;
  gap: 80px;
  padding: 60px 160px 60px 60px;
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_index__31kgK h3 {
  font-size: 7.5rem;
  margin: 0;
  font-family: "Rubik Glitch";
  font-weight: 400;
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_box_info__kbcSO {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_box_info__kbcSO h2 {
  font-family: "Beer money";
  font-size: 2rem;
  font-weight: 400;
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_box_info__kbcSO h2, .Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_box_info__kbcSO p {
  margin: 0;
}
@media (max-width: 760px) {
  .Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr {
    gap: 60px;
    padding: 40px 120px 40px 40px;
  }
}
@media (max-width: 580px) {
  .Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr {
    gap: 40px;
    padding: 20px 80px 20px 20px;
  }
}
@media (max-width: 520px) {
  .Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr {
    gap: 30px;
    padding: 15px 80px 15px 15px;
  }
  .Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_index__31kgK h3 {
    font-size: 6rem;
    line-height: 6rem;
  }
  .Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr .Values_box_info__kbcSO {
    gap: 10px;
  }
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr:nth-child(odd) {
  background-color: var(--red);
  color: var(--white);
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr:nth-child(even) .Values_index__31kgK h3 {
  color: #000;
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr:nth-child(even) .Values_box_info__kbcSO h2 {
  color: var(--red);
}
.Values_values__KR4R9 .Values_items__ihfsA .Values_item__MQIcr:nth-child(even) .Values_box_info__kbcSO p {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/components/Values/Values.module.scss"],"names":[],"mappings":"AAEG;EAFH;IAGM,iBAAA;EAAJ;AACF;AAGM;EADH;IAEM,aAAA;IACA,sBAAA;IACA,SAAA;EAAP;AACF;AAEM;EACG,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;EACA,6BAAA;AAAT;AAGY;EACG,iBAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;AADf;AAKS;EACG,aAAA;EACA,sBAAA;EACA,SAAA;AAHZ;AAKY;EACG,yBAAA;EACA,eAAA;EACA,gBAAA;AAHf;AAKY;EACG,SAAA;AAHf;AAOS;EA/BH;IAgCM,SAAA;IACA,6BAAA;EAJV;AACF;AAMS;EApCH;IAqCM,SAAA;IACA,4BAAA;EAHV;AACF;AAKS;EAzCH;IA0CM,SAAA;IACA,4BAAA;EAFV;EAIa;IACG,eAAA;IACA,iBAAA;EAFhB;EAMU;IACG,SAAA;EAJb;AACF;AAQM;EACG,4BAAA;EACA,mBAAA;AANT;AAWY;EACG,WAAA;AATf;AAcY;EACG,iBAAA;AAZf;AAeY;EACG,WAAA;AAbf","sourcesContent":[".values {\r\n\r\n   @media (max-width: 760px) {\r\n      padding-top: 20px;\r\n   }\r\n\r\n   .items {\r\n      @media (max-width: 760px) {\r\n         display: flex;\r\n         flex-direction: column;\r\n         gap: 20px;\r\n      }\r\n\r\n      .item {\r\n         box-sizing: border-box;\r\n         width: calc(100% + 100px);\r\n         display: flex;\r\n         gap: 80px;\r\n         padding: 60px 160px 60px 60px;\r\n\r\n         .index {\r\n            h3 {\r\n               font-size: 7.5rem;\r\n               margin: 0;\r\n               font-family: 'Rubik Glitch';\r\n               font-weight: 400;\r\n            }\r\n         }\r\n\r\n         .box_info{\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 20px;\r\n\r\n            h2{\r\n               font-family: \"Beer money\";\r\n               font-size: 2rem;\r\n               font-weight: 400;\r\n            }\r\n            h2, p {\r\n               margin: 0;\r\n            }\r\n         }\r\n\r\n         @media (max-width: 760px) {\r\n            gap: 60px;\r\n            padding: 40px 120px 40px 40px;\r\n         }\r\n\r\n         @media (max-width: 580px) {\r\n            gap: 40px;\r\n            padding: 20px 80px 20px 20px;\r\n         }\r\n\r\n         @media (max-width: 520px) {\r\n            gap: 30px;\r\n            padding: 15px 80px 15px 15px;\r\n            .index {\r\n               h3 {\r\n                  font-size: 6rem;\r\n                  line-height: 6rem;\r\n               }\r\n            }\r\n\r\n            .box_info{\r\n               gap: 10px;\r\n            }\r\n         }\r\n      }\r\n\r\n      .item:nth-child(odd) {\r\n         background-color: var(--red);\r\n         color: var(--white);\r\n      }\r\n\r\n      .item:nth-child(even) {\r\n         .index {\r\n            h3 {\r\n               color: #000;\r\n            }\r\n         }\r\n\r\n         .box_info {\r\n            h2 {\r\n               color: var(--red);\r\n            }\r\n\r\n            p {\r\n               color: #000;\r\n            }\r\n         }\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"values": `Values_values__KR4R9`,
	"items": `Values_items__ihfsA`,
	"item": `Values_item__MQIcr`,
	"index": `Values_index__31kgK`,
	"box_info": `Values_box_info__kbcSO`
};
export default ___CSS_LOADER_EXPORT___;
